import { Link } from "react-router-dom";
import { ProductItem } from "../../api/QuickOrder";
import { useWishlist } from "hooks/useWishlist";
import RightQualityControl from "providers/QualityControlComponent/RightQualityControl";

interface ProductListProps {
    cartItems: ProductItem[];
    onUpdateQuantity: (id: number, qty: number) => void;
}

export default function ProductList({ cartItems, onUpdateQuantity }: ProductListProps) {
    const { handleToggleWishlist, isInWishlist } = useWishlist();

    const formatCurrency = (amount: number) => {
        return amount.toLocaleString('vi-VN') + 'đ';
    }

    if (!cartItems || cartItems.length === 0) return null;

    return (
        <div className="style_wrapperContent__9ddkL">
            {cartItems.map((item) => {
                const product = item;
                const productId = product.id;

                const originalPrice = Number(product.price) || 0;
                const apiDiscountPrice = Number(product.discount_price) || 0;
                const promotionPercent = Number(product.promotion?.percent) || 0;

                const computedDiscountPrice = apiDiscountPrice > 0
                    ? apiDiscountPrice
                    : (promotionPercent > 0 ? Math.round(originalPrice * (1 - promotionPercent / 100)) : originalPrice);

                const finalPrice = computedDiscountPrice > 0 && computedDiscountPrice < originalPrice
                    ? computedDiscountPrice
                    : originalPrice;

                const finalDiscountPercent = originalPrice > 0 && finalPrice < originalPrice
                    ? Math.round((1 - finalPrice / originalPrice) * 100)
                    : 0;

                const hasPromotion = !!product.promotion;
                const promotionName = product.promotion?.detail?.name || undefined;
                const sellerName = product.product_category?.name || "Dược Tâm Hạnh";
                const sellerCategoryId = product.product_category?.id || "";

                return (
                    <div key={productId} className="style_wrapperCard__yyX_D">
                        <div className="styles_cardContainer__roWvH style_cardItem__rKGSb">
                            <div className="styles_flex__YOT7Y">
                                <Link to={`/product/${product.slug}`}>
                                    <div className="styles_wrapperImage__vkqUl" style={{ position: "relative" }}>
                                        <img src={product.avatar} alt={product.name} />
                                        <div
                                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleToggleWishlist(productId); }}
                                            role="button"
                                            style={{ position: "absolute", top: 4, right: 4, cursor: "pointer", zIndex: 1 }}
                                        >
                                            <img
                                                src={isInWishlist(productId) ? "/theme/wish_list_active.svg" : "/theme/wish_list_inactive.svg"}
                                                alt="wishlist"
                                                style={{ width: 20, height: 20 }}
                                            />
                                        </div>
                                    </div>
                                </Link>
                                <div className="styles_wrapperInfoProduct__zIAXY">
                                    <Link className="styles_name__JFs3F" to={`/product/${product.slug}`} style={{ textDecoration: "none", color: "inherit" }}>{product.name}</Link>
                                    <div className="styles_sellerContainer__zCB_8">
                                        <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative", maxWidth: "100%" }}>
                                            <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                                <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2713%27%20height=%2713%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px" }} />
                                            </span>
                                            <img src="/theme/seller_store.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                                        </span>
                                        <Link className="styles_cardNameStore__T1gCP" to={sellerCategoryId ? `/products?category=${sellerCategoryId}` : "#"}>{sellerName}</Link>
                                    </div>
                                    {hasPromotion && (
                                        <div className="styles_cardBadges__umsyP MuiBox-root css-0">
                                            <Link className="styles_mobile_rootBase__8z7PQ" to="/deals">
                                                <img alt="tag-/deals" src="/theme/Tag_Label_IconText-5.svg" title="Khuyến Mãi" />
                                            </Link>
                                            {promotionName && (
                                                <span style={{ fontSize: 12, color: "#d32f2f", marginLeft: 4 }}>{promotionName}</span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="styles_wrapperContent__K5zzD" style={{ gap: 0, marginRight: 12 }}>
                                {finalDiscountPercent > 0 && (
                                    <div className="styles_wrapperDiscount__H_zPT">
                                        <p className="MuiTypography-root styles_promo__Q5YiA MuiTypography-body1"> -{finalDiscountPercent}%</p>
                                        <Link className="styles_cardDiscount__HubGJ" to={`/product/${product.slug}`}>
                                            <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                                <div className="styles_canvasPrice__vw932 text-[15px] line-through text-[#333333]" style={{ height: "25px" }}>{formatCurrency(originalPrice)}</div>
                                            </div>
                                        </Link>
                                    </div>
                                )}
                                <div>
                                    <Link to={`/product/${product.slug}`}>
                                        <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                            <div className="styles_canvasPrice__vw932 text-[22px] text-[#428c04]" style={{ height: "34px" }}>{formatCurrency(finalPrice)}</div>
                                        </div>
                                    </Link>
                                </div>
                            </div>

                            <div className="styles_wrapperQuantityControl__LHcc9">
                                <RightQualityControl productId={productId} productName={product.name} />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}